module.exports = __webpack_public_path__ + "static/media/USC_logo.3dad8007.png";